export enum EditDeviceTab {
  ASSET_DETAILS = 'ASSET_DETAILS',
  INVENTORY_RECEIPTS = 'INVENTORY_RECEIPTS',
  ASSET_STATUS_HISTORY = 'ASSET_STATUS_HISTORY',
}
